import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
interface MidCTAProps {
  headline: string;
  subline?: string;
}
export const MidCTA: React.FC<MidCTAProps> = ({
  headline,
  subline
}) => {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7
  }} className="w-full max-w-3xl mx-auto px-6 py-16" data-id="element-125">
      <div className="relative bg-gradient-to-b from-cosmic-800/80 to-cosmic-900/80 border border-amber-500/25 rounded-2xl px-6 py-10 md:px-12 md:py-12 text-center overflow-hidden shadow-[0_0_40px_rgba(245,197,66,0.08)]" data-id="element-126">
        {/* Ambient glow */}
        <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-72 h-72 bg-amber-500/10 blur-[80px] rounded-full pointer-events-none" data-id="element-127" />

        <div className="relative z-10 flex flex-col items-center gap-6" data-id="element-128">
          <h3 className="text-2xl md:text-3xl font-serif text-amber-400 leading-tight max-w-xl" data-id="element-129">
            {headline}
          </h3>
          {subline && <p className="text-base md:text-lg font-serif italic text-amber-200/80 max-w-md" data-id="element-130">
              {subline}
            </p>}

          {/* Compact pricing */}
          <div className="flex flex-col items-center gap-2 my-2" data-id="element-131">
            <div className="inline-flex items-center justify-center px-3 py-1 text-[11px] font-bold tracking-widest text-cosmic-900 uppercase bg-amber-400 rounded-full" data-id="element-132">
              75% Descuento
            </div>
            <div className="flex items-baseline gap-3" data-id="element-133">
              <span className="text-lg text-gray-500 line-through font-serif" data-id="element-134">
                $108 USD
              </span>
              <span className="text-4xl md:text-5xl font-serif font-bold text-amber-400 drop-shadow-[0_0_15px_rgba(245,197,66,0.3)]" data-id="element-135">
                $27 USD
              </span>
            </div>
          </div>

          <CTAButton data-id="element-136">
            Comenzar el Viaje <span className="ml-2" data-id="element-137">→</span>
          </CTAButton>
        </div>
      </div>
    </motion.section>;
};